import * as React from 'react';
import { Redirect, useLocation, useParams } from 'react-router';
import { useQuery } from '@apollo/client';

import { GET_PROPERTY_REDIRECT_QUERY } from '../../../client/__graphql__/queries/getPropertyRedirect';
import NoMatch from './NoMatch';

export const RedirectToFullURL: React.FC = () => {
  const params = useParams<{ sguid: string }>();
  const location = useLocation();

  const { data, loading, error } = useQuery(GET_PROPERTY_REDIRECT_QUERY, {
    fetchPolicy: 'network-only',
    variables: {
      input: { sguid: params?.sguid },
    },
  });

  if (loading) {
    return null;
  }

  if (error?.graphQLErrors?.length && error.graphQLErrors?.length > 0) {
    if (error.graphQLErrors[0]?.extensions?.code === '404') {
      return <NoMatch />;
    }
  }

  const sguid = params.sguid;
  const urltag = data?.getProperty.office?.info?.urltag;
  const permalink = data?.getProperty?.permalink;

  if (!sguid || !urltag || !permalink) {
    return <NoMatch />;
  }

  const isMeldPaaVisning = /meldpaavisning/gi.test(location?.search);
  if (isMeldPaaVisning) {
    return <Redirect to={`/${sguid}/visningspaamelding`} />;
  } else {
    return (
      <Redirect
        to={`/${urltag}/${sguid}/${permalink}${location.search ?? ''}`}
      />
    );
  }
};
